var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockUnlocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C11.3765 12.9927 10.8143 13.3745 10.5912 13.9568C10.3681 14.5391 10.5312 15.1988 11 15.61V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V15.61C13.4688 15.1988 13.6319 14.5391 13.4088 13.9568C13.1857 13.3745 12.6235 12.9927 12 13ZM17 9H9V7C8.99702 5.78561 9.72645 4.68921 10.8477 4.22276C11.9689 3.75631 13.2608 4.01183 14.12 4.87C14.4959 5.25407 14.7649 5.72983 14.9 6.25C14.9893 6.59655 15.2567 6.86912 15.6015 6.96505C15.9463 7.06097 16.316 6.96567 16.5715 6.71505C16.827 6.46442 16.9293 6.09655 16.84 5.75C16.6122 4.8848 16.1603 4.09494 15.53 3.46C14.0989 2.03339 11.9498 1.60841 10.0835 2.38296C8.2171 3.15751 7.00043 4.97931 7 7V9C5.34315 9 4 10.3431 4 12V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V12C20 10.3431 18.6569 9 17 9ZM18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12V19Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlocked);
export default ForwardRef;